// app/javascript/controllers/client_modal_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]
  
  connect() {
    // Add event listener for client creation success
    document.addEventListener('client:created', this.closeModal.bind(this))
    
    // Add click outside to close
    document.addEventListener('click', (event) => {
      if (this.modalTarget.classList.contains('hidden')) return
      
      if (!this.modalTarget.contains(event.target) && !event.target.closest('[data-action*="client-modal#openModal"]')) {
        this.closeModal()
      }
    })
    
    // Add escape key to close
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !this.modalTarget.classList.contains('hidden')) {
        this.closeModal()
      }
    })
  }
  
  disconnect() {
    document.removeEventListener('client:created', this.closeModal.bind(this))
  }
  
  openModal() {
    this.modalTarget.classList.remove('hidden')
    document.body.classList.add('overflow-hidden') // Prevent scrolling when modal is open
  }
  
  closeModal() {
    this.modalTarget.classList.add('hidden')
    document.body.classList.remove('overflow-hidden')
    
    // Dispatch an event that can be caught by the new-event-select-client controller
    // This helps with interoperability between controllers
    document.dispatchEvent(new CustomEvent('client-modal:closed'))
  }
}
